<template>
  <div class="multimedia__content-grid">
    <chat-multimedia-empty
      v-if="isEmpty"
      :tab="$t('multimedia.documents')"
      :campaign="selectedCampaignName"
    />
    <div v-else>
      <div class="multimedia__campaign" v-if="isHistory">
        <span>
          {{ $t("multimedia.tab-from", { tab: $t("multimedia.documents") }) }}
        </span>
        <span class="multimedia__campaign-name"
          >{{ selectedCampaignName }}
        </span>
      </div>
      <div class="grid-x grid-margin-x grid-margin-y">
        <div
          v-for="(document, index) in documentsList"
          :key="index"
          class="cell small-12 medium-6"
        >
          <multimedia-document @selected="selectElement" :document="document" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MultimediaDocument from '@/components/multimedia/items/Document.vue';

export default {
  components: {
    MultimediaDocument,
    ChatMultimediaEmpty: () => import('@/components/ChatMultimediaEmpty.vue'),
  },
  props: {
    selectedCampaign: {
      type: [String, null],
    },
    selectedCampaignName: {
      type: [String, null],
    },
  },
  computed: {
    ...mapGetters([
      'activeConversation',
      'activeConversationHistory',
      'dataBankDocuments',
    ]),
    conversation() {
      return !this.isHistory
        ? this.activeConversation.conversation
        : this.activeConversationHistory.conversation;
    },
    campaignId() {
      return this.conversation.campaign.id;
    },
    documentsList() {
      return this.dataBankDocuments({
        campaignId: this.selectedCampaign,
      });
    },
    isEmpty() {
      return this.documentsList.length === 0;
    },
  },
  methods: {
    selectElement(document) {
      this.$emit('data-bank-picked', document);
    },
  },
};
</script>
